import { ListHeadingSize } from './ListHeading';
import { Theme, css } from '@emotion/react';
import { assertNever } from '@tock/shared/utils/typeUtils';

const listHeadingFontSizeFromSize = ({ typography }: Theme, listHeadingSize: ListHeadingSize) => {
  switch (listHeadingSize) {
    case 'medium':
      return css`
        ${typography.variant('body02Strong')};
      `;
    case 'large':
      return css`
        ${typography.variant('body01Strong')};
      `;
    case 'jumbo':
      return css`
        ${typography.variant('heading04')};
      `;
    default:
      assertNever(listHeadingSize);
  }
};

/**
 * Root component
 */
export const listHeading = ({ breakpoints, colors, typography, spacing }: Theme) => css`
  align-items: center;
  background-color: ${colors.bgDefault};
  box-sizing: border-box;
  color: ${colors.fgDefault};
  display: flex;
  font-family: ${typography.fontFamily};
  list-style: none;
  margin: 0 ${spacing(2.5)}px ${spacing(1.5)}px;

  ${breakpoints.up('sm')} {
    margin: 0 ${spacing(3.5)}px ${spacing(2)}px;
  }
`;

/**
 * Component traits (boolean states)
 */

export const listHeadingTall = ({ breakpoints, spacing }: Theme) => css`
  margin-bottom: ${spacing(2.5)}px;

  ${breakpoints.up('sm')} {
    margin-bottom: ${spacing(3.5)}px;
  }
`;

/**
 * Component children
 */

export const listHeadingContent = (theme: Theme, listHeadingSize: ListHeadingSize) => {
  return css`
    ${listHeadingFontSizeFromSize(theme, listHeadingSize)};
    display: flex;
    flex: 1;
    line-height: 1.3;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  `;
};
